import {COMMON_SELECTORS} from '../constants/selectors';

export const selectCartItemById = (orderId) =>
  $(COMMON_SELECTORS.ordersCartItemById.replace('_orderId_', orderId));

export const selectCartItemByTarget = (target) =>
  $(target).closest(COMMON_SELECTORS.ordersCartItem);
